module.exports = __webpack_public_path__ + "img/tech_10.310b32cb.jpg";